import { Trans } from '@lingui/macro';
import { ActionIcon, Box, SimpleGrid, Stack } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft,
  Bell,
  MessageChatbot,
  Ticket,
  Wallet,
} from 'tabler-icons-react';

import { UiCard } from '../../../components/ui/ui-card/ui-card';
import { MainSideMenu } from '../../../features/main-side-menu/main-side-menu';
import { routeCabinet } from '../../../router/routes';

import styles from './cabinet.index.page.module.css';

export const CabinetIndexPage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.backButton}>
          <ActionIcon
            variant="transparent"
            radius="50%"
            size="40px"
            bg="transparent"
            onClick={() => navigate('/')}
          >
            <ArrowLeft size={24} strokeWidth={2} color="white" />
          </ActionIcon>
        </div>
        <div className={styles.routeTitle}>
          <h1 className={styles.headerTitle}>
            <Trans>Личный кабинет</Trans>
          </h1>
        </div>
        <div className={styles.mainSideMenu}>
          <MainSideMenu />
        </div>
      </header>
      <main className={styles.main}>
        <SimpleGrid cols={2} spacing="xs">
          <UiCard onClick={() => navigate(routeCabinet.TICKETS.path)}>
            <Stack align="center" spacing="xs">
              <Ticket color="#228be6" size={32} />
              <span>
                <Trans>Мои билеты</Trans>
              </span>
            </Stack>
          </UiCard>

          <UiCard onClick={() => navigate(routeCabinet.ORDERS.path)}>
            <Stack align="center" spacing="xs">
              <Wallet color="#228be6" size={32} />
              <span>
                <Trans>Заказы</Trans>
              </span>
            </Stack>
          </UiCard>

          <UiCard onClick={() => navigate(routeCabinet.REVIEWS.path)}>
            <Stack align="center" spacing="xs">
              <MessageChatbot color="#228be6" size={32} />
              <span>
                <Trans>Отзывы</Trans>
              </span>
            </Stack>
          </UiCard>

          <UiCard
            onClick={() => navigate(routeCabinet.NOTIFICATIONS_SETTINGS.path)}
          >
            <Stack align="center" spacing="xs">
              <Bell color="#228be6" size={32} />

              <Box ta="center">
                <span>
                  <Trans>Настройка уведомлений</Trans>
                </span>
              </Box>
            </Stack>
          </UiCard>
        </SimpleGrid>
      </main>
    </div>
  );
};
